import React from 'react'

import LoginBg from '../../assets/images/LoginBg.jpg';
import Termspage1 from '../../assets/images/Termspage1.jpg';
import { Link } from 'react-router-dom';

const Terms = () => {

  return (
    <>
      <section className='AllpageheaderSection'>
        <div className='AllpageheaderSectionBg' style={{ backgroundImage: `url(${LoginBg})` }}></div>
        <div className='container'>
          <div className='row'>
            <div className='col-md-12 col-sm-12 col-xs-12'>
              <h6><Link to='/'><i className='fas fa-home'></i> Home</Link> <span className='PageHead'>TERMS & CONDITION</span></h6>
            </div>
          </div>
        </div>
      </section>
      <section className='AboutusPageSection'>
        <div className='AboutusPageSectionBg' style={{ backgroundImage: `url(${LoginBg})` }}></div>
        <div className='container'>
          <div className='row'>
            <div className='col-md-7 col-sm-7 col-xs-12'>
              <h2>Terms & Conditions</h2>
              <h3>This website is maintained and owned by OIDC, a Govt. Undertaking.</h3>
              <p> Though a great deal of efforts have been invested to ensure the accuracy of the content on this website, the same should not be construed as fit to be used for any legal purposes. Users are advised to check the veracity of the information provided on the website in case of a doubt or ambiguity. Under no circumstances, will OIDC, a Govt Undertaking shall be liable for any expense, loss or damage including, without limitation, indirect or consequential loss or use, of data, arising out of or in connection with the use of this website. The links of other important websites are provided only for your convenience and it shall not confer any responsibility on the OIDC, a Govt.Undertaking for their content and availability. </p>
            </div>

            <div className='col-md-5 col-sm-5 col-xs-12'>
              <div className='Aboutuspageimg'>
                <img src={Termspage1} alt="" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default Terms